<template>
  <div class="mc-videohistory-stream__state mc-videohistory-stream__state--novideo">
    <div>
      <img
        :src="
          isWhitelabel()
            ? getAsset('secondaryLogo', 'sidebarMinimize')
            : require('@/assets/images/mceasy-large.png')
        "
      />
      <p>{{ $t('trackVideo.state.noVideo') }}</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
      isWhitelabel: 'identity/isWhitelabel',
    }),
  },
}
</script>
